module.exports = __webpack_public_path__ + "img/saldo.34a6dd0.png";